import { render, staticRenderFns } from "./SaleReturnProductsLayout.vue?vue&type=template&id=5e355983&scoped=true"
import script from "./SaleReturnProductsLayout.vue?vue&type=script&lang=js"
export * from "./SaleReturnProductsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e355983",
  null
  
)

export default component.exports